
import {

    GET_RECONCILATION_HISTORY_FAILED,
    GET_RECONCILATION_HISTORY_SUCCESS,
    GET_RECONCILATION_HISTORY_LOADING,
} from "../types";

const initialState = {
    reconcilationData: null,
    loading: null,
    error: null,
};

export const getReconcilationHistoryReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; error: any }
) => {
    switch (action.type) {
        case GET_RECONCILATION_HISTORY_LOADING:
            return {
                ...state,
                loading: action.loading,
                error: null,
            };
        case GET_RECONCILATION_HISTORY_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                reconcilationData: action.payload,
            };
        case GET_RECONCILATION_HISTORY_FAILED:
            return {
                ...state,
                loading: false,
                error: action.error,
            };

        default:
            return state;
    }
};
